<div class="topDiv">
<!-- 
  /*
  Author- Renuka chama
  04/02/2026
  For creation of loadobjectmstr popup screen
*/ -->
    <div class="mainContent">

        <div style="height: 7vh;">
            <div>
                <label i18n="@@spmsUserReg" class="textColour">Load Objects</label>
                <span class="example-spacer"></span>
            </div>
        </div>

        <!-- <div class="content-scroll"> -->

        <div class="content-scroll">
            <form novalidate [formGroup]="FormValid" style="width: 100%;">

                <!-- Object Name -->
                <div class="row">
                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Object Name</mat-label>
                            <input matInput type="text" placeholder="Object Name" formControlName="objectName"
                                [(ngModel)]="loadObjects.objectName" required>
                            <mat-error *ngFor="let validation of
                  validation_messages.objectName">
                                <span *ngIf="FormValid.get('objectName').hasError(validation.type)
                    && (FormValid.get('objectName').dirty ||
                    FormValid.get('objectName').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- Load Order -->

                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Load Order</mat-label>
                            <input matInput type="text" placeholder="Load Order" formControlName="loadOrder"
                                [(ngModel)]="loadObjects.loadOrder" required>
                            <mat-error *ngFor="let validation of
                  validation_messages.loadOrder">
                                <span *ngIf="FormValid.get('loadOrder').hasError(validation.type)
                    && (FormValid.get('loadOrder').dirty ||
                    FormValid.get('loadOrder').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <div class=col-lg-4 style="margin: auto;">
                        <mat-checkbox class="example-margin" [checked]="loadObjects.isloadable === true"
                            (change)="onIsLoadableChange($event)" formControlName="isloadable">Is loadable
                        </mat-checkbox>
                    </div>


                    <div class=col-lg-4 style="margin: auto;">
                        <mat-checkbox class="example-margin" [checked]="loadObjects.isParent === true"
                            (change)="onIsParentChange($event)" formControlName="isParent">IsParent</mat-checkbox>
                    </div>



                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Object Level</mat-label>
                            <input matInput type="number" placeholder="Object Level" formControlName="level"
                                (input)="onLevelChange()" [(ngModel)]="loadObjects.level" required>
                            <mat-error *ngFor="let validation of
                  validation_messages.level">
                                <span *ngIf="FormValid.get('level').hasError(validation.type)
                    && (FormValid.get('level').dirty ||
                    FormValid.get('level').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>



                    <div class=col-lg-4 style="margin: auto;">
                        <mat-checkbox class="example-margin" [checked]="loadObjects.deferred === true"
                            (change)="onDeferredChange($event)" formControlName="deferred">Deferred
                            (Yes/No)</mat-checkbox>
                    </div>


                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Vault Extraction(Yes/No)</mat-label>
                            <input matInput type="text" placeholder="Vault Extraction(Yes/No)"
                                formControlName="vaultExtraction" [(ngModel)]="loadObjects.vaultExtraction" required>
                            <mat-error *ngFor="let validation of
                  validation_messages.vaultExtraction">
                                <span *ngIf="FormValid.get('vaultExtraction').hasError(validation.type)
                    && (FormValid.get('vaultExtraction').dirty ||
                    FormValid.get('vaultExtraction').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Vql Criteria</mat-label>
                            <input matInput type="text" placeholder="Vql Criteria" formControlName="vqlCriteria"
                                [(ngModel)]="loadObjects.vqlCriteria">
                        </mat-form-field>
                    </div>



                    <div class=col-lg-4 style="margin: auto;">
                        <mat-checkbox class="example-margin" [checked]="loadObjects.requiresGlobalObject === true"
                            (change)="onGlobalObjectChange($event)" formControlName="requiresGlobalObject">Global
                            Object(Yes/No)</mat-checkbox>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Object Type</mat-label>
                            <input matInput type="text" placeholder="Object Type" formControlName="objectType"
                                [(ngModel)]="loadObjects.objectType" required>
                            <mat-error *ngFor="let validation of
                  validation_messages.objectType">
                                <span *ngIf="FormValid.get('objectType').hasError(validation.type)
                    && (FormValid.get('objectType').dirty ||
                    FormValid.get('objectType').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>File Name</mat-label>
                            <mat-select formControlName="fileName" [(ngModel)]="loadObjects.fileName"
                                (selectionChange)="onFileNameChange($event.value)" required>
                    
                                <mat-option *ngFor="let item of fileNameList" [value]="item.fileName"> {{ item.displayName }}
                                </mat-option>
                    
                            </mat-select>
                            <mat-error *ngFor="let validation of
                                      validation_messages.fileName">
                                <span *ngIf="FormValid.get('fileName').hasError(validation.type)
                                        && (FormValid.get('fileName').dirty ||
                                        FormValid.get('fileName').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Deletion Level</mat-label>
                            <input matInput type="text" placeholder="Deletion Level" formControlName="deletionLevel"
                                [(ngModel)]="loadObjects.deletionLevel">
                        </mat-form-field>
                    </div>





                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Load Action</mat-label>
                            <input matInput type="text" placeholder="Load Action" formControlName="loadAction"
                                [(ngModel)]="loadObjects.loadAction">
                        </mat-form-field>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Parent ObjectName For Extraction</mat-label>
                            <input matInput type="text" placeholder="Parent ObjectName For Extraction"
                                formControlName="parentObjectNameForExtraction"
                                [(ngModel)]="loadObjects.parentObjectNameForExtraction">
                        </mat-form-field>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Source Data ExtractionVQL</mat-label>
                            <input matInput type="text" placeholder="Source Data ExtractionVQL"
                                formControlName="sourceDataExtractionVql"
                                [(ngModel)]="loadObjects.sourceDataExtractionVql">
                        </mat-form-field>
                    </div>





                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Object GroupName</mat-label>
                            <input matInput type="text" placeholder="Object GroupName" formControlName="objectgroupname"
                                [(ngModel)]="loadObjects.objectgroupname">
                        </mat-form-field>
                    </div>




                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>migrationmode</mat-label>
                            <input matInput type="text" placeholder="migrationmode" formControlName="migrationmode"
                                [(ngModel)]="loadObjects.migrationmode">
                        </mat-form-field>
                    </div>


                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Self Reference Object</mat-label>

                            <!-- <mat-select multiple formControlName="selfreferenceobject"
                                [(ngModel)]="loadObjects.selfreferenceobject">

                                <mat-option *ngFor="let file of selfReferenceFileList" [value]="file">
                                    {{ file }}
                                </mat-option>

                            </mat-select> -->
                            <mat-select multiple formControlName="selfreferenceobject">
  <mat-option
    *ngFor="let obj of selfReferenceFileList"
    [value]="obj.fileName">
    {{ obj.fileName }}
  </mat-option>
</mat-select>
                        </mat-form-field>
                    </div>


                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Self Reference Fields</mat-label>
                            <input matInput readonly placeholder="Self Reference Fields"
                                formControlName="selfreferencefields" (click)="openSelfReferenceFieldsPopup()">
                        </mat-form-field>
                    </div>


                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Circular Reference Object</mat-label>

                            <!-- <mat-select multiple formControlName="circularreferenceobject"
                                [(ngModel)]="loadObjects.circularreferenceobject">

                                <mat-option *ngFor="let file of selfReferenceFileList" [value]="file">
                                    {{ file }}
                                </mat-option>

                            </mat-select> -->
                             <mat-select multiple formControlName="circularreferenceobject">
  <mat-option
    *ngFor="let obj of circularReferenceFileList"
    [value]="obj.fileName">
    {{ obj.fileName }}
  </mat-option>
</mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Circular Reference Fields</mat-label>
                            <input matInput readonly placeholder="Circular Reference Fields"
                                formControlName="circularreferencefields" (click)="openCircularReferenceFieldsPopup()">
                        </mat-form-field>
                    </div>


                </div>


            </form>
        </div>

        <!-- Footer Buttons -->
        <div style="height: 1vh;">
            <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%; ">
                <div class="col-lg text-center">
                    <div style="text-align: end; ">
                        <form novalidate [formGroup]="formValidCheckbox">
                            <span *ngIf="showCreateAnother">
                                <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected"
                                    style="margin-right:1%" class="mat-checkbox-layout"></mat-checkbox>
                                <span>Create another</span>
                            </span>

                            <button i18n="@@TargetClear" type="button"
                                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                [style.background-color]="backgroundColorButton" (click)="saveMethod()"
                                style="padding: .3rem 1.6rem; font-size: .85rem; width:150px; color: white;">
                                {{this.buttonName}}
                            </button>

                            <button i18n="@@TargetCancel" type="button"
                                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                (click)="cancel()" [style.background-color]="backgroundColorButton"
                                style="padding: .3rem 1.6rem; font-size: .85rem; width:150px; color: white;">Cancel</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>